import Axios from "axios";
import qs from "qs";

const instance = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(async (config) => {
  config.headers["Authorization"] = `Bearer ${localStorage.getItem(
    "authenticated"
  )}`;
  return config;
});

instance.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if(error.response.status == 401) {
    localStorage.removeItem("authenticated");
    window.location.reload();
  }
  return Promise.reject(error);
});

export default instance;
